import React from "react";
import { makeStyles } from "@material-ui/styles";
import { AutoSizer } from "react-virtualized";
import MapPermissionGuard from "./MapPermissionGuard";
import MapPanZoomWrapper from "./MapPanZoomWrapper";

const getInitialCampus = () => {
  if (typeof window === "undefined") return 1;
  const params = new URLSearchParams(window.location.search);
  const campusParam = params.get("campus");

  // リロード時にtargetパラメータを削除し、campusのみを保持する
  if (params.has("target")) {
    params.delete("target");
    const newQuery = params.toString();
    const newUrl =
      window.location.pathname +
      (newQuery ? `?${newQuery}` : "") +
      window.location.hash;
    window.history.replaceState({}, "", newUrl);
  }

  return campusParam ? Number(campusParam) : 1;
};

const useStyles = makeStyles((theme) => ({
  svg: {
    width: "100vw",
    height: window.innerHeight,
  },
  wrapper: {
    width: "100vw",
    height: window.innerHeight,
  },
  tools: {
    position: "absolute",
    top: "0",
    zIndex: "999",
  },
  actionHeader: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(2),
  },
  margin: {
    marginRight: theme.spacing(1),
  },
}));

export default function MapInterface() {
  const classes = useStyles();
  const initialCampus = getInitialCampus();

  return (
    <div className={classes.wrapper}>
      <AutoSizer>
        {({ width, height }) =>
          width === 0 || height === 0 ? null : (
            <MapPermissionGuard>
              {({ gpsEnabled, updateGpsEnabled }) => (
                <MapPanZoomWrapper
                  width={width}
                  height={height}
                  gpsEnabled={gpsEnabled}
                  updateGpsEnabled={updateGpsEnabled}
                  initialCampus={initialCampus}
                />
              )}
            </MapPermissionGuard>
          )
        }
      </AutoSizer>
    </div>
  );
}
